import Vue from 'vue'
import Config from '@/config'

export default {
	state: {
		requests: [],
		requestsLoaded: false,
		unreadNotifications: [],
	},
	getters: {
		requests(state) {
			return state.requests
		},
		requestsLoaded(state) {
			return state.requestsLoaded
		},
		unreadNotifications(state) {
			return state.unreadNotifications
		},
	},
	mutations: {
		clearRequests(state) {
			// Clear requests from state and flag store status as not loaded
			state.requests = []
			state.requestsLoaded = false
		},
		destroyMessage(state, data) {
			// Delete message from state
			if (state.requests.length > 0) {
				let indexRequest = -1
				let indexResponse = -1
				let indexMessage = -1

				// Loop over requests
				Object.entries(state.requests).forEach(([indexReq, request]) => {
					// Loop over responses
					Object.entries(request.responses).forEach(([indexRes, response]) => {
						// Loop over messages
						Object.entries(response.messages).forEach(([indexMsg, message]) => {
							// Check current message
							if (message !== undefined && message.id === data.messageId) {
								indexRequest = indexReq
								indexResponse = indexRes
								indexMessage = indexMsg
							}
						})
					})
				})

				// Delete message
				state.requests[indexRequest].responses[indexResponse].messages.splice(indexMessage, 1)
			}
		},
		destroyRequest(state, data) {
			// Delete request from state
			if (state.requests.length > 0) {
				let indexRequest = -1

				// Loop over requests
				Object.entries(state.requests).forEach(([indexReq, request]) => {
					// Check current request
					if (request !== undefined && request.id === data.requestId) {
						indexRequest = indexReq
					}
				})

				// Delete request
				state.requests.splice(indexRequest, 1)
			}
		},
		setMessage(state, data) {
			// Add message to state
			if (state.requests.length > 0) {
				let indexRequest = -1
				let indexResponse = -1

				// Loop over requests
				Object.entries(state.requests).forEach(([indexReq, request]) => {
					// Loop over responses
					Object.entries(request.responses).forEach(([indexRes, response]) => {
						// Check current response
						if (response !== undefined && response.id === data.responseId) {
							indexRequest = indexReq
							indexResponse = indexRes
						}
					})
				})

				// Add message
				state.requests[indexRequest].responses[indexResponse].messages.push(data.messageObj)
			}
		},
		setRequest(state, data) {
			// Add request to state
			state.requests.push(data.requestObj)
		},
		setRequests(state, data) {
			// Set requests to state and flag store status as loaded
			state.requests = data
			state.requestsLoaded = true
		},
		setUnreadNotificationsWithToast(state, value) {
			// Check if value is changed before
			if (state.unreadNotifications.length !== 0 && state.unreadNotifications.length !== value.length) {
				// Reload requests for updating data
				state.requestsLoaded = false
				this.dispatch('retrieveRequests')
			}

			// Set unreadNotifications value
			state.unreadNotifications = value
		},
		setUnreadNotificationsNoToast(state, value) {
			// Check if value is changed before
			if (state.unreadNotifications.length !== 0 && state.unreadNotifications.length !== value.length) {
				// Reload requests for updating data
				state.requestsLoaded = false
				this.dispatch('retrieveRequests')
			}

			// Set unreadNotifications value
			state.unreadNotifications = value
		},
		updateMessage(state, data) {
			// Update message into state
			if (state.requests.length > 0) {
				let indexRequest = -1
				let indexResponse = -1
				let indexMessage = -1

				// Loop over requests
				Object.entries(state.requests).forEach(([indexReq, request]) => {
					// Loop over responses
					Object.entries(request.responses).forEach(([indexRes, response]) => {
						// Loop over messages
						Object.entries(response.messages).forEach(([indexMsg, message]) => {
							// Check current message
							if (message !== undefined && message.id === data.messageId) {
								indexRequest = indexReq
								indexResponse = indexRes
								indexMessage = indexMsg
							}
						})
					})
				})

				// Update message
				state.requests[indexRequest].responses[indexResponse].messages[indexMessage].text = data.messageText
			}
		},
		updateRequest(state, data) {
			// Update request into state
			const indexRequest = state.requests.findIndex((request) => request.id === data.requestId)

			if (data.part) {
				state.requests[indexRequest].request_type.id = data.requestTypeId
			}
			if (data.part) {
				state.requests[indexRequest].part = data.part
			}
			if (data.latitude && data.longitude) {
				state.requests[indexRequest].geo.address_full = data.city
				state.requests[indexRequest].geo.city = data.city
				state.requests[indexRequest].geo.country_id = data.country_id
				state.requests[indexRequest].geo.latitude = data.latitude
				state.requests[indexRequest].geo.longitude = data.longitude
				state.requests[indexRequest].geo.province_id = data.province_id
			}
			if (data.description) {
				state.requests[indexRequest].description = data.description
			}
			if (data.documents) {
				state.requests[indexRequest].documents = data.documents
			}
			if (data.status) {
				state.requests[indexRequest].status.id = data.status
				state.requests[indexRequest].status.label = Vue.helpers.getRequestStatusLabelById(data.status, data.locale)
			}
			if (data.extra) {
				state.requests[indexRequest].extra = data.extra
			}
			if (data.plan) {
				state.requests[indexRequest].plan.id = data.plan
				state.requests[indexRequest].plan.label = Vue.helpers.getRequestPlanLabelById(data.plan, data.locale)
			}
			if (data.invoice) {
				state.requests[indexRequest].invoice = data.invoice
			}
			if (data.feedback) {
				state.requests[indexRequest].feedback.updated = data.feedback.updated
				state.requests[indexRequest].feedback.satisfaction_lawyer = data.feedback.satisfaction_lawyer
				state.requests[indexRequest].feedback.satisfaction_site = data.feedback.satisfaction_site
				state.requests[indexRequest].feedback.review_lawyer = data.feedback.review_lawyer
				state.requests[indexRequest].feedback.review_site = data.feedback.review_site
			}
		},
		updateResponse(state, data) {
			// Update response into state
			if (state.requests.length > 0) {
				let indexRequest = -1
				let indexResponse = -1

				// Loop over requests
				Object.entries(state.requests).forEach(([indexReq, request]) => {
					// Loop over responses
					Object.entries(request.responses).forEach(([indexRes, response]) => {
						// Check current response
						if (response !== undefined && response.id === data.responseId) {
							indexRequest = indexReq
							indexResponse = indexRes
						}
					})
				})

				// Update response
				if (data.status) {
					state.requests[indexRequest].responses[indexResponse].status.id = data.status
					state.requests[indexRequest].responses[indexResponse].status.label = Vue.helpers.getResponseStatusLabelById(
						data.status,
						data.locale
					)
				}
				if (data.text) {
					state.requests[indexRequest].responses[indexResponse].text = data.text
				}
				if (data.lawyer) {
					state.requests[indexRequest].responses[indexResponse].lawyer = data.lawyer
				}
				if (data.responsePercentage) {
					state.requests[indexRequest].responses[indexResponse].percentage = Number(data.responsePercentage)
				}
				if (data.responseIncludedExpenses) {
					state.requests[indexRequest].responses[indexResponse].additional_costs = Boolean(
						data.responseIncludedExpenses
					)
				}
				if (data.responseFixedCosts) {
					state.requests[indexRequest].responses[indexResponse].fixed_costs = Number(data.responseFixedCosts)
				}
			}
		},
	},
	actions: {
		clearRequests(context) {
			context.commit('clearRequests')
		},
		destroyMessage(context, data) {
			return new Promise((resolve, reject) => {
				// Set the authorization header to axios
				axios.defaults.headers.common.Authorization = 'Bearer ' + context.rootState.auth.token

				axios
					.delete('/messages/' + data.messageId)
					.then((response) => {
						// Commit mutation
						context.commit('destroyMessage', {
							messageId: data.messageId,
							responseId: data.responseId,
						})

						resolve(response)
					})
					.catch((error) => {
						console.log(error)
						reject(error)
					})
			})
		},
		destroyRequest(context, data) {
			return new Promise((resolve, reject) => {
				// Set the authorization header to axios
				axios.defaults.headers.common.Authorization = 'Bearer ' + context.rootState.auth.token

				axios
					.delete('/requests/' + data.requestId)
					.then((response) => {
						// Commit mutation
						context.commit('destroyRequest', {
							requestId: data.requestId,
						})

						resolve(response)
					})
					.catch((error) => {
						console.log(error)
						reject(error)
					})
			})
		},
		readAllNotifications(context) {
			// Set the authorization header to axios
			axios.defaults.headers.common.Authorization = 'Bearer ' + context.rootState.auth.token

			// Read all notifications
			axios
				.get('/notifications/read/all')
				.then(() => {
					// Do nothing
				})
				.catch((error) => {
					console.log(error)
				})
		},
		retrieveRequests(context) {
			if (!context.rootState.data.requestsLoaded && context.rootGetters.loggedIn) {
				// Set the authorization header to axios
				axios.defaults.headers.common.Authorization = 'Bearer ' + context.rootState.auth.token

				// Retrieve requests
				axios
					.get(context.rootGetters.isUser ? '/requests/user' : '/requests/lawyer', {
						params: {
							page: -1,
							page_size: -1,
						},
					})
					.then((response) => {
						if (response.data.info) {
							context.commit('setRequests', response.data.info)
						} else {
							context.commit('setRequests', [])
						}
					})
					.catch(() => {
						// Do not log on errors
					})
			}
		},
		retrieveUnreadNotifications(context, data) {
			// Set the authorization header to axios
			axios.defaults.headers.common.Authorization = 'Bearer ' + context.rootState.auth.token

			// Retrieve unread notifications
			axios
				.get('/notifications/unread')
				.then((response) => {
					// Manage mutation type according to "toast" flag in data parameter
					const mutationType = data && data.toast ? 'setUnreadNotificationsWithToast' : 'setUnreadNotificationsNoToast'
					if (response.data.info) {
						// On unread notifications commit a mutation
						context.commit(mutationType, response.data.info)
					} else {
						// Set no unread notifications
						context.commit(mutationType, [])
					}
				})
				.catch((error) => {
					if (error.response && error.response.status === 401) {
						// Unauthorized, logout account and clear requests,
						// tokens and account data from store
						localStorage.removeItem('ius_access_token')
						sessionStorage.removeItem('ius_access_token')

						context.commit('clearRequests')
						context.commit('clearToken')
						context.commit('clearAccount')
					}
					console.log(error)
				})
		},
		storeMessage(context, data) {
			return new Promise((resolve, reject) => {
				// Set the authorization header to axios
				axios.defaults.headers.common.Authorization = 'Bearer ' + context.rootState.auth.token

				axios
					.post('/messages', {
						user_id: data.userId,
						lawyer_id: data.lawyerId,
						response_id: data.responseId,
						text: data.messageText,
						type: data.messageType,
					})
					.then((response) => {
						// Customize message response data
						const messageObj = response.data.info
						messageObj.response = data.responseId

						// Commit mutation
						context.commit('setMessage', {
							responseId: data.responseId,
							messageObj: messageObj,
						})

						resolve(response)
					})
					.catch((error) => {
						console.log(error)
						reject(error)
					})
			})
		},
		storeRequest(context, data) {
			return new Promise((resolve, reject) => {
				// Set the authorization header to axios
				axios.defaults.headers.common.Authorization = 'Bearer ' + context.rootState.auth.token

				axios
					.post('/requests', {
						request_type_id: data.requestType,
					})
					.then((response) => {
						// Commit mutation
						context.commit('setRequest', {
							requestObj: response.data.info,
						})

						resolve(response)
					})
					.catch((error) => {
						console.log(error)
						reject(error)
					})
			})
		},
		storeUnreadNotifications(context, value) {
			// Commit mutation
			context.commit('setUnreadNotificationsNoToast', value)
		},
		updateMessage(context, data) {
			return new Promise((resolve, reject) => {
				// Set the authorization header to axios
				axios.defaults.headers.common.Authorization = 'Bearer ' + context.rootState.auth.token

				axios
					.put('/messages/' + data.messageId, {
						text: data.messageText,
					})
					.then((response) => {
						// Commit mutation
						context.commit('updateMessage', {
							messageId: data.messageId,
							messageText: data.messageText,
							responseId: data.responseId,
						})

						resolve(response)
					})
					.catch((error) => {
						console.log(error)
						reject(error)
					})
			})
		},
		updateRequest(context, data) {
			if (data.updateDatabase) {
				// Update API and store (if extra or plan fields are provided)
				return new Promise((resolve, reject) => {
					// Set the authorization header to axios
					axios.defaults.headers.common.Authorization = 'Bearer ' + context.rootState.auth.token

					axios
						.put('/requests/' + data.requestId, {
							request_type_id: data.requestType,
							part: data.requestPart,
							city: data.geo.city,
							latitude: data.geo.latitude,
							longitude: data.geo.longitude,
							province_id: data.geo.province_id,
							country_id: data.geo.country_id,
							description: data.requestDescription,
							documents: data.requestDocuments,
							extra: data.extra,
							plan: data.plan,
							invoice: data.invoice,
							discount: data.discount,
							status: data.status,
							cart_id: data.cartId,
							sale_id: data.saleId,
						})
						.then((response) => {
							// Commit mutation
							context.commit('updateRequest', {
								requestId: data.requestId,
								requestTypeId: data.requestType,
								part: data.requestPart,
								city: data.geo.city,
								latitude: data.geo.latitude,
								longitude: data.geo.longitude,
								provinceId: data.geo.province_id,
								countryId: data.geo.country_id,
								description: data.requestDescription,
								documents: data.requestDocuments,
								status: data.status,
								extra: data.extra,
								plan: data.plan,
								invoice: data.invoice,
								feedback: data.feedback,
								locale: data.locale,
							})

							resolve(response)
						})
						.catch((error) => {
							console.log(error)
							reject(error)
						})
				})
			} else {
				// Update only store
				context.commit('updateRequest', {
					requestId: data.requestId,
					status: data.status,
					feedback: data.feedback,
				})
			}
		},
		updateResponse(context, data) {
			return new Promise((resolve, reject) => {
				// Set the authorization header to axios
				axios.defaults.headers.common.Authorization = 'Bearer ' + context.rootState.auth.token

				axios
					.put('/responses/' + data.responseId, {
						status: data.status,
						text: data.text,
						percentage: data.responsePercentage,
						additional_costs: data.responseIncludedExpenses,
						fixed_costs: data.responseFixedCosts,
					})
					.then((response) => {
						// Commit mutation
						context.commit('updateResponse', {
							responseId: data.responseId,
							status: data.status,
							text: data.text,
							lawyer: response.data && response.data.info && response.data.info.lawyer ? response.data.info.lawyer : '',
							responsePercentage: data.responsePercentage,
							responseIncludedExpenses: data.responseIncludedExpenses,
							responseFixedCosts: data.responseFixedCosts,
							locale: data.locale,
						})

						// Update also the request in store (committing the mutation) if is approved
						if (data.status === Config.RESPONSE_STATUS_APPROVED) {
							context.commit('updateRequest', {
								requestId: data.requestId,
								status: Config.REQUEST_STATUS_APPROVED,
							})
						}

						resolve(response)
					})
					.catch((error) => {
						console.log(error)
						reject(error)
					})
			})
		},
	},
}



// WEBPACK FOOTER //
// ./src/store/modules/data.js